module.exports = __webpack_public_path__ + "img/loginNew1.562756b5.png";